import ReactMarkdown, { Options } from "react-markdown";
import remarkGfm from "remark-gfm";

// Old Safari support (e.g. 15.3 on macOS Catalina). Without it, any page rendering markdown crashes.
// react-markdown calls Object.hasOwn (Safari 15.4+) on every render.
if (!Object.hasOwn) {
  Object.defineProperty(Object, "hasOwn", {
    value: (object: object, key: PropertyKey) => Object.prototype.hasOwnProperty.call(object, key),
    configurable: true,
    writable: true,
  });
}

// remark-gfm builds a lookbehind RegExp (Safari 16.4+). Without it, render plain markdown: no tables or autolinks.
function supportsRegexLookbehind() {
  try {
    new RegExp("(?<=a)b");
    return true;
  } catch {
    return false;
  }
}

const gfmPlugins = supportsRegexLookbehind() ? [remarkGfm] : [];

export default function Markdown({ gfm = false, ...options }: Options & { gfm?: boolean }) {
  return <ReactMarkdown {...options} remarkPlugins={gfm ? gfmPlugins : options.remarkPlugins} />;
}
